@if (currentInstructionPage$ | async; as instructionPage) {
  <elder-pane class="full">
    <!-- Navigation -->
    <elder-pane-header>
      <!-- Title and Description -->
      <elder-pane-title>{{ instructionPage.instruction.taskName }}</elder-pane-title>
      @if (instructionPage.instruction.taskDescription) {
        <span class="text-body-small">
          {{ instructionPage.instruction.taskDescription }}
        </span>
      }
      <!-- Actions -->
      <div class="layout-row gap-xxl">
        <!-- Printing -->
        <app-print-button
          appPrintCommand
          color="primary"
          [reportSpec]="labelReport$ | async"
          [printOptions]="documentPrintOptions$ | async"
          [disabled]="!(printingEnabled$ | async)"
        >
        </app-print-button>
        <!-- Navigation -->
        <div class="layout-row gap-sm place-start-center">
          <button
            [disabled]="!hasPrevious"
            (click)="previousInstruction()"
            [color]="'primary'"
            mat-flat-button
          >
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <span
            >{{ (currentInstructionIndex$ | async) + 1 }} /
            {{ (instructionPages$ | async).length }}</span
          >
          <button
            [disabled]="!hasNext"
            (click)="nextInstruction()"
            [color]="'primary'"
            mat-flat-button
          >
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </div>
      </div>
    </elder-pane-header>
    <!-- Attachment viewer -->
    <elder-pane-content>
      <div class="flex layout-col gap-sm instruction-content">
        @for (attachment of instructionPage.instruction.attachments; track attachment) {
          <elder-blob-viewer
            class="flex"
            url="{{ attachment.downloadUrl }}"
            mimeType="{{ attachment.mimeType }}"
          ></elder-blob-viewer>
        }
      </div>
    </elder-pane-content>
  </elder-pane>
}
